module.exports = __webpack_public_path__ + "media/components/helpcenter/TasksHelp/TaskAdd1-5b99c53f92b6823d6aa581df1ffee6db.jpg";